import { resize } from 'FileManagerCore/utils/resize';
export default resize;